module.exports = __webpack_public_path__ + "media/images/admin/icons/photo_camera-bf57179bde8c139491f50299d6f1802a.png";